import React, {Component} from 'react';
import {Box, Grid, LinearProgress, MenuItem, TextField, withStyles} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";

import {getDashboardItems} from "../../stores/api";
import CookielessLookerEmbed from "./cookielessEmbed";

@inject("userStore")
@observer
class DashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardItems: [],
      loading: false,
      searchValue: "",
      selectedDashboard: null
    };
  }

  componentDidMount() {
    const selectedId = this.props.match?.params?.id;
    this.setState({ loading: true });
    getDashboardItems().then(res => {
      if (res.ok && res.data) {
        this.setState({
          dashboardItems: res.data,
          selectedDashboard: res.data.find(item => item.id === selectedId)
        });
      } else {
        this.setState({ dashboardItems: [] });
      }
      this.setState({ loading: false });
    });
  }

  viewDashboardItem = (item) => {
    this.setState({ selectedDashboard: item });
    this.props.history.push(`/dashboards/${item.id}`);
  }

  render() {
    const { userStore, match } = this.props;
    const { dashboardItems, loading, searchValue, selectedDashboard } = this.state;
    const { clientSettings } = userStore;
    const showDashboards = clientSettings?.settings?.enable_dashboards === 'true' && userStore.isClientAdmin;
    const selectedId = match.params?.id;

    if (!showDashboards) return null;

    return (
      <Box>
        <Grid container spacing={2} style={{height: "calc(100vh - 105px)"}}>
          <Grid item style={{height: "100%"}}>
            <Box px={1} style={{backgroundColor: "#fff", height: "100%"}}>
              <Box py={1} fontSize={14}>
                <TextField
                  value={searchValue}
                  onChange={e => this.setState({ searchValue: e.target.value })}
                  placeholder="Search..."
                  margin="dense"
                  variant="standard"
                  fullWidth
                />
              </Box>
              <Box style={{overflowY: "auto", height: "calc(100% - 60px)"}}>
                {loading && <LinearProgress color="#887fff" />}
                {dashboardItems.filter(item => item.name.toLowerCase().includes(searchValue.toLowerCase())).map(item => {
                  const isSelected = selectedId === item.id;
                  return (
                    <MenuItem
                      key={item.id}
                      onClick={() => this.viewDashboardItem(item)}
                      style={{
                        backgroundColor: isSelected ? "#4dc481" : undefined,
                        color: isSelected ? "#fff" : undefined,
                        padding: 10,
                        marginBottom: 4
                      }}
                    >
                      {item.name}
                    </MenuItem>
                  )
                })}
              </Box>
            </Box>
          </Grid>
          <Grid item style={{flexGrow: 1}}>
            <Box style={{backgroundColor: "#fff", height: "100%"}}>
              {!selectedId && <Box p={3}>Please select a dashboard on the left to view</Box>}
              {selectedId && <CookielessLookerEmbed dashboard={selectedDashboard} />}
            </Box>
          </Grid>
        </Grid>
      </Box>
    )
  }
}

export default withRouter(DashboardContainer);